import { useCallback } from 'react';
import { permissionClient, UpdateScopeModel } from '@bymason/controller-api';
import { useGetDataHook, useSaveDataHook } from '@bymason/api-hooks-base';

export { PermissionSet, ScopeModel } from '@bymason/controller-api';

/**
 * React hook that asynchronously gets an all availble permissions.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetScopes(clientToken: string) {
  const handleGetData = useCallback(() => {
    return permissionClient.getScopes(clientToken);
  }, [clientToken]);

  return useGetDataHook(handleGetData);
}

/**
 * React hook that asynchronously gets users with their permission.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetAccountPermissions(clientToken: string) {
  const handleGetData = useCallback(() => {
    return permissionClient.getAccountPermissions(clientToken);
  }, [clientToken]);

  return useGetDataHook(handleGetData);
}

/**
 * React hook that asynchronously updates a user's scope
 * @returns HookArray
 * @HookArray [0] post method
 * @HookArray [1] void
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 */
export function useUpdateScope(clientToken: string) {
  const handleSaveData = useCallback(
    (data: UpdateScopeModel[]) => {
      return permissionClient.updateScopes(data, clientToken);
    },
    [clientToken]
  );
  return useSaveDataHook(handleSaveData);
}
